<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <fuse-sidebar class="sidebar" name="supplier-order-main-sidebar" position="left" lockedOpen="gt-md">
        <supplier-order-main-sidebar></supplier-order-main-sidebar>
    </fuse-sidebar>
    <!-- CONTENT -->
    <div class="center mat-card" *ngIf="supplierOrder != null">
        <selling-navbar></selling-navbar>

        <div class="content-card" style="overflow-y: scroll;">
            <div class="h2 mt-16">{{ 'Delivery details'|translate }}: {{supplierOrder.items.length}} {{'products'|translate}}</div>
            <br/>
            <table class="table">
                <thead>
                <tr>
                    <td>{{'No.'|translate}}</td>
                    <td>{{'Name'|translate}}</td>
                    <td>{{'Net price'|translate}}</td>
                    <td>{{'Gross price'|translate}}</td>
                    <td>{{'Quantity'|translate}}</td>
                    <td>{{'VAT'|translate}}</td>
                    <td>{{'Gross value'|translate}}</td>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of supplierOrder.items; index as i">
                    <td>{{i+1}}</td>
                    <td>{{item.product.name}}</td>
                    <td>{{item.priceNet}}</td>
                    <td>{{item.priceGross}}</td>
                    <td>{{item.quantity}}</td>
                    <td>{{item.vatRate}}</td>
                    <td>{{item.priceGross * item.quantity}}</td>
                </tr>
                </tbody>
            </table>
            <br/>
            <br/>
            <table class="table">
                <tr>
                    <td>{{'Supplier'|translate}}</td>
                    <td>{{supplierOrder.supplier.name}}</td>
                </tr>
                <tr>
                    <td>{{'Invoice number'|translate}}</td>
                    <td>{{supplierOrder.invoiceNumber}}</td>
                </tr>
                <tr>
                    <td>{{'Description'|translate}}</td>
                    <td>{{supplierOrder.description}}</td>
                </tr>
            </table>
        </div>
    </div>
</div>
